export default __webpack_public_path__ + "static/bakstol-example1-3ac247f2437fcc8deaf4c03580dd9978.png";